import axios, { AxiosInstance } from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Local, Session } from '@/utils/storage';
import log from '@/utils/log';
import qs from 'qs';
import { get, debounce } from 'lodash';
import storesAppConfig from '@/store/appConfig';


// 配置新建一个 axios 实例
const service: AxiosInstance | any = axios.create({
	baseURL: import.meta.env.VITE_API_PREFIX,
	timeout: import.meta.env.DEV ? 30000 : 60000,
	headers: { 'Content-Type': 'application/json' },
	paramsSerializer: {
		serialize(params) {
			return qs.stringify(params, { allowDots: true });
		},
	},
});

// 添加请求拦截器
service.interceptors.request.use(
	(config: { headers: { [x: string]: string }; noTimeout: boolean; timeout: number }) => {
		// 在发送请求之前做些什么 token
		if (Session.get('token')) config.headers!['Authorization'] = `${Session.get('token')}`;
		if (storesAppConfig.code) config.headers['App-Id'] = storesAppConfig.code;
		if (config.noTimeout) {
			config.timeout = 0;
		}
		// if (storesAppConfig.code && `${Session.get("loginAppId")}` != 'null') {
		//   console.log(`${Session.get("loginAppId")}`,111);

		//   config.headers["App-Id"] = `${Session.get("loginAppId")}`
		// } else
		//  config.headers["App-Id"] = ''
		// config.headers["App-Id"] = `${Session.get("loginAppId")}` == null ? '' : `${Session.get("loginAppId")}`
		// 注：此处Ent-id应后端要求取值为tyshxydm
		if (Session.get('tyshxydm')) config.headers['Ent-Id'] = `${Session.get('tyshxydm')}`;
		return config;
	},
	(error: any) => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加响应拦截器
service.interceptors.response.use(
	(response: any) => {
		// console.log(response, 111);
		const { config } = response;
		if (
			response.request.responseURL.includes('/jxgl/jxgl/jdfp/printPDF?qxxkdm=1') ||
			response.request.responseURL.includes('/jxgl/cjfp/downloadFilesForFpcj')
		) {
			return response;
		}

		// 对下载文件做特殊处理
		if (!response.headers['content-type']?.includes('application/json')) {
			return response;
		}
		// 对响应数据做点什么
		const res = response.data;
		const { code, msg, message } = res;
		// 状态码不存在则非后端请求接口
		if (code === undefined) {
			return Promise.resolve(response);
		}
		if (response.config.noErrorHand) {
			return res;
		}
		// 处理后端状态码
		switch (code) {
			case 200:
				return res;
			case 0:
				return res;
			case -1:
				!config.silent && ElMessage.error(res.message || res.msg || '未知错误');
				return Promise.reject(res);
			case -99:
				if (!errorController.handled) return Promise.reject(res);
				Session.clear();
				Local.clear();
				errorController.handled = false;
				ElMessageBox.confirm('您已被登出，请重新登录', '提示', {
					showCancelButton: false,
					confirmButtonClass: 'el-button el-button--primary el-button--large waves-effect',
				})
					.then(async () => {
						errorController.handled = true;
						const { reloadChannel } = await import('@/utils/channel');
						reloadChannel('logout');
					})
					.catch(() => {});
				return Promise.reject(res);
			default:
				const error = { message: msg || message };
				!config.silent && getErrorMsg(error, code);
		}
		return Promise.reject(response);
	},
	(error: any) => {
		if (!error.response) {
			// 来自服务端或浏览器
			if (error.message.indexOf('timeout') != -1) {
				error.message = '请求超时';
			} else if (error.message == 'Network Error') {
				error.message = '网络连接错误';
			} else {
				getErrorMsg(error, get(error, 'request.status'));
			}
		} else {
			// 来自API接口
			let { status, code, msg, message } = get(error, 'response.data');
			status = status || code;
			status = status || get(error, 'response.status');
			// 优先使用 message 或 msg 字段，其次是 error_description，最后才是 statusText
			error.message = message || msg || get(error, 'response.data.error_description');
			error.message = error.message || get(error, 'response.statusText');
			getErrorMsg(error, status);
		}

		errorLog(error);
		return Promise.reject(error);
	}
);

function getErrorMsg(error: any, status: number) {
	switch (status) {
		case 10001:
			error.message = '登录失败：' + error.message;
			break;
		case 400:
			error.message = error.message || '请求错误，请稍后再试！';
			break;
		case 401:
			//特殊处理
			if (!errorController.handled) return;
			error.message = '未授权，请登录';
			Session.clear(); // 清除浏览器全部临时缓存
			errorController.handled = false;
			ElMessageBox.confirm('您已被登出，请重新登录', '提示', {
				showCancelButton: false,
				confirmButtonClass: 'el-button el-button--primary el-button--large waves-effect',
				// cancelButtonClass: "el-button el-button--large is-plain"
			})
				.then(() => {
					errorController.handled = true;
					window.location.href = '/'; // 去登录页
				})
				.catch(() => {})
				.finally(() => {
					errorController.handled = true;
					window.location.href = '/'; // 去登录页
				});
			break;
		case 403:
			// error.message = '拒绝访问';
			break;
		case 404:
			error.message = '请求地址不存在';
			break;
		case 408:
			error.message = '请求超时';
			break;
		case 500:
			error.message = '服务器内部错误';
			break;
		case 501:
			error.message = '服务未实现';
			break;
		case 502:
			error.message = '网关错误';
			break;
		case 503:
			error.message = '服务不可用';
			break;
		case 504:
			error.message = '网关超时';
			break;
		case 505:
			error.message = 'HTTP版本不受支持';
			break;
		default:
			break;
	}
	errorLog(error);
}

// 异常控制器，主要用于限流
const errorController = {
	error: undefined as any,
	handled: true, //如果是false，则表示有其它逻辑正在处理，不希望被打扰
	handler: debounce(showErrorMsg, 500), //限流
};

// 记录和显示错误
function errorLog(error: any) {
	// 打印到控制台
	if (import.meta.env.DEV) {
		log.danger('>>>>>> Error >>>>>>');
		// eslint-disable-next-line no-console
		console.log(error);
	}

	//执行控制器显示错误信息
	errorController.error = error;
	errorController.handler();
}

function showErrorMsg() {
	if (!errorController.handled) return;
	// 显示提示
	ElMessage({
		message: errorController.error.message,
		type: 'error',
		duration: 5 * 1000,
	});
}

// 导出 axios 实例
export default service;
